<template>
  <iframe
    class="iframe-reporte"
    src="https://app.powerbi.com/view?r=eyJrIjoiZWZlMjU0YWYtMTY2YS00NTBjLTliM2YtYjU1ZWNjNmUwM2E2IiwidCI6IjJkZGQ3ZTNlLTI4YjAtNGJjMy1hYWFiLWMwZTZiOTg0ODgzZSIsImMiOjR9&pageName=ReportSection"
    frameborder="0"
    allowfullscreen="true"
  ></iframe>
</template>

<script>
export default {
  name: "reporte",
};
</script>

<style scoped>
.iframe-reporte {
  width: 100%;
  height: 100%;
}
</style>
